import { LoadingButton } from "@mui/lab";
import {
  TableRow,
  TableCell,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import PointStatusChip from "Components/UI/Tables/PointsStatusChip";
import { Link } from "react-router-dom";

const ConnectionsTable = ({ connectedInvoices, handleOnRemove, loading }) => {
  return (
    <Table sx={{ minWidth: "1500px" }}>
      <TableHead>
        <TableRow>
          <TableCell align="left">Dokumenttyp</TableCell>
          <TableCell align="left">Fakturanummer</TableCell>
          <TableCell align="left">Fakturadatum</TableCell>
          <TableCell align="left">Förfallodatum</TableCell>
          <TableCell align="left">OCR</TableCell>
          <TableCell align="left">Ursp belopp</TableCell>
          <TableCell align="left">Kvarst belopp</TableCell>
          <TableCell align="left">Klientnummer</TableCell>
          <TableCell align="left">Klientnamn</TableCell>
          <TableCell align="left">Kundnummer</TableCell>
          <TableCell align="left">Kundnamn</TableCell>
          <TableCell align="left">Matchpoäng</TableCell>
          <TableCell align="left">Kopplad summa</TableCell>
          <TableCell align="center" />
        </TableRow>
      </TableHead>
      <TableBody>
        {connectedInvoices.map((connectedInvoice, index) => {
          return (
            <TableRow key={index}>
              <TableCell>{connectedInvoice?.DocumentType}</TableCell>
              <TableCell>
                <Link
                  to={`/invoices/${connectedInvoice?.InvoiceId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {connectedInvoice?.ExternalInvoiceNumber}
                </Link>
              </TableCell>
              <TableCell>{connectedInvoice?.InvoiceDate}</TableCell>
              <TableCell>{connectedInvoice?.InvoiceFfd}</TableCell>
              <TableCell>{connectedInvoice?.OCR}</TableCell>
              <TableCell>{connectedInvoice?.OriginalAmount}</TableCell>
              <TableCell>{connectedInvoice?.InvoiceAmountLeft}</TableCell>
              <TableCell>{connectedInvoice?.ClientNumber}</TableCell>
              <TableCell>{connectedInvoice?.ClientName}</TableCell>
              <TableCell>{connectedInvoice?.EndCustomerNumber}</TableCell>
              <TableCell>{connectedInvoice?.Name}</TableCell>
              <TableCell>
                <PointStatusChip point={connectedInvoice?.Points} />
              </TableCell>
              <TableCell>{Number(connectedInvoice?.Amount ?? 0)}</TableCell>
              <TableCell sx={{ padding: "0px", textAlign: "center" }}>
                {connectedInvoice?.DocumentType !== "JUSTERING" ? (
                  <LoadingButton
                    variant="contained"
                    color="error"
                    size="small"
                    loading={loading}
                    onClick={() => handleOnRemove(connectedInvoice)}
                  >
                    Avkoppla
                  </LoadingButton>
                ) : null}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ConnectionsTable;
